// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"37":"9eebef2a","99":"c2be37da","104":"1122ea75","310":"36336606","358":"17be7559","637":"97136af9"}[chunkId] + ".js";
};